import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserRole } from './UserRoleProvider';

// The HR tool. Access is the `hr-access` grant and nothing else — not admin, and not the
// hr-confidential role, both of which used to show it. The tool has no API of its own, so this guard and
// the gear menu are the whole of the gate, and both read the same grant.
const HRRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { hasHrAccess, isLoading, rolesUnknown } = useUserRole();

  // Role lookup failed — we don't know whether access is permitted, so don't imply it isn't.
  if (rolesUnknown) {
    return (
      <div className="page">
        <div className="page-content">
          <div className="loading-message">
            <p>We couldn't confirm your access. Please reload the page or sign in again.</p>
          </div>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="page">
        <div className="page-content">
          <div className="loading-message"><p>Checking access...</p></div>
        </div>
      </div>
    );
  }

  if (!hasHrAccess) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default HRRoute;
